import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setMobileActiveSide } from '../../actions/mobileSide';
import { ChatHeaderUser } from '../../components/ChatHeader';
import { ChatCompanionTitle } from '../../components/ChatCompanionTitle';
import { hostTypeSelector } from '../../selectors';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { EMobileLayoutActiveSide } from '../../types/mobileSide';
import { useApplicationContext } from '../../utils/applicationContext';
import { CompanionStatusContainer } from '../ChatHeaderUserContainer/containers';

export const ChatHeaderChatbotContainer = () => {
  const {
    custom: { realDevice },
  } = useApplicationContext();
  const hostType = useSelector(hostTypeSelector);

  const isIframe = hostType === EHostType.Frame;
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  const dispatch = useDispatch();

  const handleClickBack = () => {
    dispatch(setMobileActiveSide(EMobileLayoutActiveSide.Left));
  };

  return (
    <ChatHeaderUser
      showBackButton={isMobile && !isIframe}
      isDesktopIframe={isIframe && realDevice === EDeviceType.Desktop}
      handleClickBack={handleClickBack}
      companionTitle={<ChatCompanionTitle primaryText="Циан-помощник" dataTestId="chat_header_title" />}
      callButtonNode={null}
      chatMenuNode={null}
      companionStatus={<CompanionStatusContainer companionId={0} />}
      chatStarredNode={null}
    />
  );
};
